<template>
  <v-dialog v-model="dialogVisible" max-width="400">
    <v-card>
      <v-card-title class="dialog-title-small">
        <div>
          Delete station <span class="station-name">{{ station.name }}</span><br>
          This cannot be undone<br>Confirm?
        </div>
      </v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" class="white--text" @click="onConfirm">OK</v-btn>
        <v-btn color="primary" class="white--text" @click="close">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true
  },
  station: {
    type: Object,
    required: true
  }
})

const emit = defineEmits(['update:modelValue', 'confirm'])

const dialogVisible = ref(props.modelValue)
watch(() => props.modelValue, (val) => {
  dialogVisible.value = val
})
watch(dialogVisible, (val) => {
  if (val !== props.modelValue) emit('update:modelValue', val)
})

function close() {
  dialogVisible.value = false
}

function onConfirm() {
  emit('confirm')
  dialogVisible.value = false
}
</script>

<style scoped>
.station-name {
  font-size: 1.3em;
  font-weight: bold;
}
.dialog-title-small {
  font-size: 1rem !important;
  font-weight: 500;
}
</style>